module.exports = __webpack_public_path__ + "img/absolut-reg-form-bg.23a9d53c.jpg";